module.exports = __webpack_public_path__ + "10c6505a621cc5ffc8d976aedead1db2.png";